module.exports = __webpack_public_path__ + "static/img/08.95281fb1.webp";